var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 89,
    viewBox: "0 0 500 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_30113_104050)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243.098 24.8164H187.867L186.562 32.2468H241.806L243.098 24.8164Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.793 48.7594H232.028C231.418 51.7148 229.431 58.3674 223.365 63.7158C213.817 72.0556 201.038 76.4707 186.381 76.4707H185.304L183.892 83.3985H184.251C204.101 83.3985 219.333 78.6843 229.599 69.3993C238.465 61.3707 240.75 55.077 242.485 48.8073L243.897 41.6641H182.061L180.793 48.7594Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.286 24.7422H127.548L117.426 83.0843H129.092L133.627 57.1438H170.862L172.13 50.0485H134.871L139.286 24.7422Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.035 25.0195H363.309L361.789 33.7661H321.18L319.911 41.1127H353.832L306.391 83.3616L319.66 83.2779L359.301 47.9807L353.174 83.3616H364.876L372.223 41.1127H381.281L382.573 33.7661H373.515L375.035 25.0195Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.98 57.4196H438.441L439.745 50.3242H386.249L384.98 57.4196Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.349 25.0195H455.611L445.477 83.3616H457.155L461.713 57.4212H498.733L500.002 50.3258H462.922L467.349 25.0195Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.536 32.604L314.84 24.707L247.321 54.931L245.969 63.2468L277.497 49.116L271.526 83.3602H281.996L288.672 44.0906L309.456 34.7817L313.536 32.604Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.2169 1.49642C99.8612 -0.154771 102.41 -0.465866 103.762 0.694755C105.138 1.85537 105.09 4.2843 103.654 6.9286L98.1622 17.087L68.8715 71.2653L63.3794 81.4237C61.9436 84.068 59.3472 86.4969 56.7268 87.6336C54.1064 88.7942 51.8929 88.4592 51.0434 86.808L30.7505 47.2751L0 62.2794L29.1232 44.0924L23.1645 31.5888L33.658 41.2447L97.2169 1.49642ZM58.2464 65.7254L81.5665 22.579L36.9364 44.2719L58.2464 65.7134V65.7254Z",
    fill: "url(#paint0_linear_30113_104050)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_30113_104050",
    x1: 0,
    y1: 44.1642,
    x2: 104.755,
    y2: 44.1642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0EB1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30113_104050"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 88.3268,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.75a6457c48ba048ed2354212c7456fc9.svg";
export { ForwardRef as ReactComponent };